/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store/index";
import { AttributePrototypeDetailed, AttributePrototypesList } from "@/models/api/Attributes";
import { getAttributePrototype, getAttributePrototypes } from "@/requests/attributes";

export interface AttributesStateInterface {
  prototypes: AttributePrototypesList | null;
}

export const AttributesState: AttributesStateInterface = {
  prototypes: null,
};

const AttributesModule = defineModule({
  state: AttributesState as AttributesStateInterface,
  namespaced: true as const,
  getters: {
    prototypes(...args): AttributePrototypesList {
      const { state } = _moduleGetterContext(args);
      if (state.prototypes) {
        return state.prototypes;
      }
      return [];
    },
    attributeCode:
      (...args) =>
      (id: number | null) => {
        const { getters } = _moduleGetterContext(args);
        const attribute = getters.prototypes.find((x) => x.id == id);
        if (attribute) return attribute.code;
        return "";
      },
  },
  mutations: {
    setAttributePrototypes(state, param: AttributePrototypesList | null) {
      state.prototypes = param;
    },
  },
  actions: {
    async downloadPrototypes(context): Promise<void> {
      const { state, commit } = _moduleActionContext(context);
      if (state.prototypes === null) {
        const response = await getAttributePrototypes();
        commit.setAttributePrototypes(response);
      }
    },
    async getAttributePrototype(context, attributePrototypeId: number): Promise<AttributePrototypeDetailed> {
      return await getAttributePrototype(attributePrototypeId);
    },
  },
});

export default AttributesModule;

/* eslint-disable  @typescript-eslint/no-explicit-any */
//eslint-disable-next-line
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, AttributesModule);
const _moduleActionContext = (context: any) => moduleActionContext(context, AttributesModule);
